import { Box } from "@chakra-ui/react";
import Tab, { TabProps } from "components/Tab";

type FilledTabProps = TabProps;

const FilledTab = ({ isActive, ...rest }: FilledTabProps) => (
  <Box bg={isActive ? "dark.400" : "dark.500"} w="full" transition="all 0.15s">
    <Tab
      w="full"
      display="flex"
      activeColor="secondary.500"
      unactiveColor="bright.500"
      isActive={isActive}
      {...rest}
    />
  </Box>
);

export default FilledTab;
